<template>
  <div class="failure-complete">
    <div class="form-section">
      <!-- 故障处理完成状态 -->
      <div class="form-row">
        <div class="form-field">
          <p class="form-field-title">故障处理完成：</p>
          <el-select
            v-model="faultCompletedStatus"
            placeholder="请选择处理完成状态"
            class="form-field-select"
            
          >
            <el-option label="设备寄回" :value="1"></el-option>
            <el-option label="不可修复-废弃" :value="2"></el-option>
            <el-option label="设备入库" :value="3"></el-option>
          </el-select>
        </div>
      </div>

      <!-- 根据不同状态显示不同的表单内容 -->
      
      <!-- 1. 设备寄回 -->
      <template v-if="faultCompletedStatus === 1">
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>原负责人：</p>
            <el-select
              v-model="originalPersonId"
              placeholder="原负责人"
              class="form-field-select"
              filterable
              disabled
            >
              <el-option
                v-for="person in personList"
                :key="person.value"
                :label="person.label"
                :value="person.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">关联机构：</p>
            <el-select
              v-model="outboundHospitalId"
              placeholder="请选择机构"
              class="form-field-select"
              filterable
              :disabled="isHospitalFieldDisabled"
             
            >
              <el-option
                v-for="hospital in hospitalList"
                :key="hospital.value"
                :label="hospital.label"
                :value="hospital.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">单号：</p>
            <el-input
              v-model="returnTrackingNumber"
              placeholder="请输入单号"
              class="form-field-input"
            />
          </div>
          <div class="form-field">
            <p class="form-field-title">接收人：</p>
            <el-input
              v-model="receiver"
              placeholder="请输入接收人"
              class="form-field-input"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">接收地址：</p>
            <el-input
              v-model="receiveAddress"
              type="textarea"
              placeholder="请输入接收地址"
              class="form-field-textarea"
              :rows="2"
            />
          </div>
        </div>
      </template>

      <!-- 2. 不可修复-废弃 -->
      <template v-if="faultCompletedStatus === 2">
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>废弃说明：</p>
            <el-input
              v-model="scrapReason"
              type="textarea"
              placeholder="请输入废弃说明"
              class="form-field-textarea"
              :rows="3"
            />
          </div>
        </div>
      </template>

      <!-- 3. 设备入库 -->
      <template v-if="faultCompletedStatus === 3">
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>新负责人：</p>
            <el-select
              v-model="newPersonId"
              placeholder="请选择新负责人"
              class="form-field-select"
              filterable
              :disabled="isPersonFieldDisabled"
            >
              <el-option
                v-for="person in personList"
                :key="person.value"
                :label="person.label"
                :value="person.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import { Select, Option, Input } from "element-ui";

export default {
  name: "FailureComplete",
  
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    hospitalList: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    return {
      faultCompletedStatus: 1,
      originalPersonId: null, // 设备寄回的原负责人
      newPersonId: null, // 设备入库的新负责人
      outboundHospitalId: null,
      returnTrackingNumber: "",
      receiver: "",
      receiveAddress: "",
      scrapReason: "",
      personList: [],
    };
  },

  computed: {
    // 判断负责人字段是否禁用（销售经理时禁用）
    isPersonFieldDisabled() {
      return this.$store.getters.isSalesManager;
    },

    // 判断机构字段是否禁用（有机构时禁用）
    isHospitalFieldDisabled() {
      return !!(this.deviceData && this.deviceData.outboundHospitalId);
    },
  },

  async mounted() {
    await this.getPersonList();
    this.initializeFormData();
    console.log('this.hospitalList', this.hospitalList)
  },

  methods: {
    async getPersonList() {
      try {
        // 获取负责人列表
        const response = await this.$api.getResponsiblePersonList();
        this.personList = response.map(item => ({
          value: item.id,
          label: item.trueName
        }));
      } catch (error) {
        console.error('获取人员列表失败:', error);
      }
    },

    initializeFormData() {
      // 初始化原负责人（用于设备寄回）
      if (this.deviceData && this.deviceData.outboundPersonId) {
        this.originalPersonId = this.deviceData.outboundPersonId;
      }
      
      // 初始化关联机构
      if (this.deviceData && this.deviceData.outboundHospitalId) {
        this.outboundHospitalId = this.deviceData.outboundHospitalId;
      }
    },

    onSubmit: function () {
      // 验证必填字段
      if (this.faultCompletedStatus === 1) {
        // 设备寄回验证
        if (!this.originalPersonId) {
          this.$toast.showRed("请选择原负责人");
          return;
        }
      } else if (this.faultCompletedStatus === 2) {
        // 不可修复-废弃验证
        if (!this.scrapReason.trim()) {
          this.$toast.showRed("请填写废弃说明");
          return;
        }
      } else if (this.faultCompletedStatus === 3) {
        // 设备入库验证
        if (!this.newPersonId) {
          this.$toast.showRed("请选择新负责人");
          return;
        }
      }
     
      // 构造提交数据，根据不同状态使用不同的负责人字段
      const submitData = {
        id: this.deviceData.maintenanceOrderId,
        faultCompletedStatus: this.faultCompletedStatus,
        outboundPersonId: this.faultCompletedStatus === 1 ? this.originalPersonId : this.newPersonId,
        outboundHospitalId: this.outboundHospitalId,
        returnTrackingNumber: this.returnTrackingNumber,
        receiver: this.receiver,
        receiveAddress: this.receiveAddress,
        scrapReason: this.scrapReason,
      };
     
      this.$emit("onSubmit", submitData);
    },
  },
};
</script>

<style lang="scss" scoped>
.failure-complete {
  width: 100%;

  .form-section {
    padding: rem(10) 0;
  }

  .required {
    color: #ff4d4f;
  }

  .form-row {
    display: flex;
    gap: rem(20);
    margin-bottom: rem(16);

    .form-field {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
        font-size: rem(14);
      }

      &-select,
      &-input {
        ::v-deep .el-input {
          height: rem(32);
        }
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(80);
          font-family: inherit;
        }
      }
    }
  }
}
</style>